// links that start with these prefixes will be ignored by the click handler
const CLICK_IGNORE_PREFIXES = ["#", "/inventoryservice", "/admin"];

/**
 * Returns a click handler that intercepts link clicks inside CMS-rendered HTML and
 * routes internal links through the Nuxt router, while letting external links,
 * hash anchors, and other special prefixes pass through to the browser.
 */
export function useCmsLinkInterceptor() {
    function handleClick(e: MouseEvent) {
        const target = e.target as HTMLElement;

        if (!target) return;

        const anchor = target.closest("a");
        if (!anchor) return;

        const href = anchor.getAttribute("href");
        /**
         * Allows hash-based navigation (e.g., #section-id) and external links to function normally
         * without being intercepted by the router. This regex pattern typically matches:
         * - Anchor links starting with # (internal page navigation)
         * - External URLs with protocols (http://, https://, etc.)
         * - Email links (mailto:)
         * - Phone links (tel:)
         *
         * Links matching this pattern will bypass client-side routing and use default browser behavior,
         * ensuring proper navigation within the CMS document and to external resources.
         */
        if (
            !href ||
            CLICK_IGNORE_PREFIXES.some((path) => href.startsWith(path)) ||
            /^[a-zA-Z][a-zA-Z0-9+\-.]*:/.test(href)
        ) {
            return;
        }

        // Respect modified clicks and non-left-button clicks
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
            return;
        }

        e.preventDefault();
        return navigateTo(href);
    }

    return { handleClick };
}
